const TO_HANDLE = 0;
const WAITING_FOR_APPROVAL = 1;
const APPROVED = 2;
const REJECTED = 3;
const SUSPENDED = 4;

export { TO_HANDLE, WAITING_FOR_APPROVAL, APPROVED, REJECTED, SUSPENDED };
